import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { getKnowledgeBaseOnboardingPath } from '../../routing/utils/internalPaths';
import KnowledgeBaseSelect from './KnowledgeBaseSelect';
import { getIsUngatedForKnowledgeBaseV3_1 } from '../../selectors/gates';
import KnowledgeBaseMigrationSelect from './KnowledgeBaseMigrationSelect';
import { useAppSelector } from '../../utils/hooks';
import KnowledgeBaseSelectWrapper from '../../content-listing/components/KnowledgeBaseSelectWrapper';
import { selectCurrentKb } from '../../knowledge-base/selectors/knowledgeBaseDetails';
import { jsx as _jsx } from "react/jsx-runtime";
const KnowledgeBaseSwitcher = props => {
  const isUngatedForKBv3_1 = useAppSelector(getIsUngatedForKnowledgeBaseV3_1);
  const {
    id: currentKbId
  } = useAppSelector(selectCurrentKb);
  const history = useHistory();
  const handleSelectKnowledgeBase = useCallback(newKnowledgeBaseId => {
    if (currentKbId) {
      const updatedPathName = history.location.pathname.replace(`${currentKbId}`, `${newKnowledgeBaseId}`);
      history.push(updatedPathName);
    }
  }, [history, currentKbId]);
  return props.isCmpEnabled ? /*#__PURE__*/_jsx(KnowledgeBaseSelectWrapper, Object.assign({
    onSelectKnowledgeBase: handleSelectKnowledgeBase
  }, props)) : isUngatedForKBv3_1 ? /*#__PURE__*/_jsx(KnowledgeBaseMigrationSelect, Object.assign({
    "data-test-id": "knowledge-base-switcher",
    buttonUse: "transparent",
    onAddKnowledgeBaseClick: () => history.push(`${getKnowledgeBaseOnboardingPath()}?cancel=back`),
    onSelectKnowledgeBase: handleSelectKnowledgeBase,
    selectedKnowledgeBaseId: currentKbId
  }, props)) : /*#__PURE__*/_jsx(KnowledgeBaseSelect, Object.assign({
    "data-test-id": "knowledge-base-switcher",
    buttonUse: "transparent",
    onAddKnowledgeBaseClick: () => history.push(`${getKnowledgeBaseOnboardingPath()}?cancel=back`),
    onSelectKnowledgeBase: handleSelectKnowledgeBase,
    selectedKnowledgeBaseId: currentKbId
  }, props));
};
export default KnowledgeBaseSwitcher;